import React from 'react'
import { Card, Row, Col } from 'react-bootstrap';

import SingleLeyendLabel from '../../../../support/SingleLeyendLabel';

const GenericCardRenderItems = ({ data = {}, labels = [] }) => {

  const renderLeyends = (item) => {
    return (
      <SingleLeyendLabel
        key={ item.index }
        label={ item.label }
        index={ item.index }
        data={ data }
        render={ item.render }
      />
    )
  }

  return (
    <Card className="mb-2">
      <Card.Body>
        <Row className="d-block mt-2 mb-2">
          <Col>
            { labels.map(renderLeyends) }
          </Col>
        </Row>
      </Card.Body>
    </Card>
  )
}

export default GenericCardRenderItems;
